import WhiteNavbar from "components/Navbars/WhiteNavbar";
import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Spinner,
  Row,
  Col,
  Table,
  Badge,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";
import Footer from "components/Footers/Footer";
import {
  FaInfoCircle,
  FaCalculator,
  FaTrash,
  FaPrint,
  FaIdCard,
  FaCarCrash,
  FaTimesCircle,
} from "react-icons/fa";

const TrafikKazaTazminatHesaplama = () => {
  // State
  const [formData, setFormData] = useState({
    adSoyad: "",
    cinsiyet: "",
    dogumTarihi: "",
    kazaTarihi: "",
    gelir: "",
    maluliyetOrani: "",
    kusurOrani: "",
    tedaviMasraflari: "",
    telefon: "",
  });

  const [sonuc, setSonuc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hata, setHata] = useState(null);
  const [formGosterildi, setFormGosterildi] = useState(true);
  const [validationErrors, setValidationErrors] = useState({});

  const currentUser = "ARS Hukuk";
  const [currentDate, setCurrentDate] = useState(
    new Date().toLocaleString("tr-TR")
  );

  // Effects
  useEffect(() => {
    AOS.init();
    const t = setInterval(
      () => setCurrentDate(new Date().toLocaleString("tr-TR")),
      1000
    );
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const targetLink = document.querySelector('a[data-gt-lang="tr"]');
    if (targetLink) {
      targetLink.click();
      const imgElement = document.querySelector(".gt-current-lang img");
      const newImgSrc = "https://cdn.gtranslate.net/flags/32/tr.png";
      if (imgElement) {
        imgElement.src = newImgSrc;
        imgElement.width = "32";
        imgElement.height = "32";
      }
    }
  }, []);

  // Yardımcı fonksiyonlar
  const yasiHesapla = (dogumTarihi) => {
    if (!dogumTarihi) return null;
    const dogum = new Date(dogumTarihi);
    const bugun = new Date();
    let yas = bugun.getFullYear() - dogum.getFullYear();
    const m = bugun.getMonth() - dogum.getMonth();
    if (m < 0 || (m === 0 && bugun.getDate() < dogum.getDate())) yas--;
    return yas;
  };

  // Handlers
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (validationErrors[name])
      setValidationErrors((prev) => ({ ...prev, [name]: null }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.dogumTarihi) errors.dogumTarihi = "Doğum tarihi zorunludur";
    if (!formData.kazaTarihi) errors.kazaTarihi = "Kaza tarihi zorunludur";
    if (!formData.telefon) errors.telefon = "Telefon numarası zorunludur";

    if (!formData.gelir) errors.gelir = "Gelir bilgisi zorunludur";
    else if (parseFloat(formData.gelir) <= 0)
      errors.gelir = "Gelir sıfırdan büyük olmalıdır";

    if (!formData.maluliyetOrani)
      errors.maluliyetOrani = "Maluliyet oranı zorunludur";
    else {
      const m = parseFloat(formData.maluliyetOrani);
      if (isNaN(m)) errors.maluliyetOrani = "Geçerli bir oran giriniz";
      else if (m <= 0 || m > 100)
        errors.maluliyetOrani =
          "Maluliyet oranı 0'dan büyük ve 100'den küçük olmalıdır";
    }

    if (formData.dogumTarihi) {
      const yas = yasiHesapla(formData.dogumTarihi);
      if (yas !== null && (yas < 18 || yas > 80))
        errors.dogumTarihi = "Yaş 18 ile 80 arasında olmalıdır";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      setHata("Lütfen işaretli alanları kontrol edin ve eksikleri tamamlayın.");
      return;
    }
    setLoading(true);
    setHata(null);

    try {
      // Kendi endpoint'inize veri gönder
      await fetch("https://your-api-endpoint.com/api/tazminat-hesaplama", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          tarih: currentDate,
        }),
      });
    } catch (error) {
      console.error("Veri kaydedilemedi:", error);
    }

    try {
      await hesaplamaSimulasyonu();
      setFormGosterildi(false);
    } catch (error) {
      setHata(error.message);
      setSonuc(null);
    } finally {
      setLoading(false);
    }
  };

  const hesaplamaSimulasyonu = () =>
    new Promise((resolve) => {
      setTimeout(() => {
        const yas = yasiHesapla(formData.dogumTarihi);
        const gelir = parseFloat(formData.gelir);
        const maluliyetOrani = parseFloat(formData.maluliyetOrani) / 100;
        const kusurOrani = parseFloat(formData.kusurOrani || "0") / 100;
        const tedaviMasraflari = parseFloat(formData.tedaviMasraflari || "0");

        const calismaSuresi = Math.max(65 - yas, 0);
        let maddiTazminat = gelir * maluliyetOrani * calismaSuresi * 12;
        const pasifTazminat = gelir * maluliyetOrani * 15 * 12 * 0.6;
        maddiTazminat += pasifTazminat;
        maddiTazminat *= 1 - kusurOrani;

        const maneviTazminat = maddiTazminat * 0.3;
        const toplamTazminat =
          maddiTazminat + maneviTazminat + (tedaviMasraflari || 0);

        setSonuc({
          hesaplamaBilgileri: {
            adSoyad: formData.adSoyad || "Belirtilmemiş",
            yas,
            cinsiyet: formData.cinsiyet,
            kazaTarihi: formData.kazaTarihi,
            dogumTarihi: formData.dogumTarihi,
            gelir,
            maluliyetOrani: formData.maluliyetOrani,
            kusurOrani: formData.kusurOrani || "0",
            tedaviMasraflari: tedaviMasraflari || 0,
            telefon: formData.telefon,
          },
          tazminatDetaylari: {
            maddiTazminat: Math.round(maddiTazminat),
            maneviTazminat: Math.round(maneviTazminat),
            tedaviMasraflari: tedaviMasraflari || 0,
            toplamTazminat: Math.round(toplamTazminat),
          },
          hesaplamaDetaylari: {
            aktifCalismaSuresi: calismaSuresi,
            pasifDonem: 15,
            islemTarihi: currentDate,
            hesaplayanKullanici: currentUser,
            raporNo: `TKH-${Math.floor(Math.random() * 1000000)}`,
          },
        });
        resolve();
      }, 900);
    });

  const formuTemizle = () => {
    setFormData({
      adSoyad: "",
      cinsiyet: "",
      dogumTarihi: "",
      kazaTarihi: "",
      gelir: "",
      maluliyetOrani: "",
      kusurOrani: "",
      tedaviMasraflari: "",
      telefon: "",
    });
    setValidationErrors({});
    setHata(null);
  };

  const yeniHesaplamayap = () => {
    setFormGosterildi(true);
    setSonuc(null);
    setHata(null);
    setValidationErrors({});
  };

  const sonucuYazdir = () => {
    if (!sonuc) return;
    const { hesaplamaBilgileri, tazminatDetaylari, hesaplamaDetaylari } =
      sonuc;
    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      alert("Lütfen açılır pencere engelleyicisini devre dışı bırakın.");
      return;
    }
    printWindow.document.write(`
      <html>
      <head>
        <title>Trafik Kazası Tazminat Raporu</title>
        <style>
          body { font-family: 'Segoe UI', Arial, sans-serif; margin: 40px; color: #344767; line-height: 1.65; }
          .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #123274; padding-bottom: 20px; color: #123274; }
          .logo { margin-bottom: 15px; display: flex; justify-content: center; }
          .logo-circle { width: 60px; height: 60px; border-radius: 50%; background: #123274; color: white; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 24px; }
          .header h2 { font-size: 28px; margin: 15px 0 10px; font-weight: 700; }
          .header p { color: #495057; margin-top: 5px; }
          .result { border: 1px solid #e0e0e0; border-radius: 10px; padding: 30px; margin-bottom: 35px; background: #f9f9f9; box-shadow: 0 5px 15px rgba(0,0,0,0.05); }
          .result h3 { color: #123274; border-bottom: 1px solid #e0e0e0; padding-bottom: 15px; margin-bottom: 25px; font-size: 22px; font-weight: 700; }
          table { width: 100%; border-collapse: collapse; }
          th { padding: 12px; text-align: left; border-bottom: 2px solid #e0e0e0; background: #f8f9fa; color: #344767; font-weight: 700; }
          td { padding: 12px; border-bottom: 1px solid #e0e0e0; }
          .footer { margin-top: 40px; font-size: 12px; text-align: center; color: #6c757d; border-top: 1px solid #e0e0e0; padding-top: 15px; }
          .total-box { text-align: center; background: #fff; border-radius: 8px; padding: 18px; box-shadow: 0 2px 8px rgba(0,0,0,.05); margin: 20px 0; }
          .total-label { font-size: 14px; color: #6c757d; font-weight: 700; text-transform: uppercase; }
          .total-value { font-size: 28px; font-weight: 900; color: #123274; margin-top: 6px; }
        </style>
      </head>
      <body>
        <div class="header">
          
          <h2>TRAFİK KAZASI TAZMİNAT RAPORU</h2>
          <p>Rapor No: ${
            hesaplamaDetaylari.raporNo
          } | Tarih: ${currentDate}</p>
        </div>

        <div class="result">
          <h3>TOPLAM TAZMİNAT</h3>
          <div class="total-box">
            <div class="total-label">Toplam Tazminat Tutarı</div>
            <div class="total-value">${tazminatDetaylari.toplamTazminat.toLocaleString(
              "tr-TR"
            )} ₺</div>
          </div>
        </div>

        <div class="result">
          <h3>HESAPLAMA PARAMETRELERİ</h3>
          <table>
            <tbody>
              <tr><th style="width:40%">Ad Soyad</th><td>${
                hesaplamaBilgileri.adSoyad
              }</td></tr>
              <tr><th>Yaş</th><td>${hesaplamaBilgileri.yas}</td></tr>
              <tr><th>Cinsiyet</th><td>${
                hesaplamaBilgileri.cinsiyet
                  ? hesaplamaBilgileri.cinsiyet === "erkek"
                    ? "Erkek"
                    : "Kadın"
                  : "-"
              }</td></tr>
              <tr><th>Doğum Tarihi</th><td>${
                hesaplamaBilgileri.dogumTarihi
              }</td></tr>
              <tr><th>Kaza Tarihi</th><td>${
                hesaplamaBilgileri.kazaTarihi
              }</td></tr>
              <tr><th>Telefon</th><td>${
                hesaplamaBilgileri.telefon || "-"
              }</td></tr>
              <tr><th>Aylık Gelir</th><td>${(+hesaplamaBilgileri.gelir).toLocaleString(
                "tr-TR"
              )} ₺</td></tr>
              <tr><th>Maluliyet Oranı</th><td>%${
                hesaplamaBilgileri.maluliyetOrani
              }</td></tr>
              <tr><th>Kusur Oranı</th><td>%${
                hesaplamaBilgileri.kusurOrani
              }</td></tr>
              ${
                hesaplamaBilgileri.tedaviMasraflari
                  ? `<tr><th>Tedavi Masrafları</th><td>${(+hesaplamaBilgileri.tedaviMasraflari).toLocaleString(
                      "tr-TR"
                    )} ₺</td></tr>`
                  : ""
              }
            </tbody>
          </table>
        </div>

        <div class="result">
          <h3>TAZMİNAT DETAYLARI</h3>
          <table>
            <tbody>
              <tr><th style="width:40%">Maddi Tazminat</th><td>${tazminatDetaylari.maddiTazminat.toLocaleString(
                "tr-TR"
              )} ₺</td></tr>
              <tr><th>Manevi Tazminat</th><td>${tazminatDetaylari.maneviTazminat.toLocaleString(
                "tr-TR"
              )} ₺</td></tr>
              <tr><th>Toplam</th><td><strong>${tazminatDetaylari.toplamTazminat.toLocaleString(
                "tr-TR"
              )} ₺</strong></td></tr>
            </tbody>
          </table>
        </div>

        <div class="footer">
          <p>Bu rapor bilgilendirme amaçlıdır. Yasal işlemlerde kullanmadan önce bir uzmana danışınız.</p>
          <p>© ${new Date().getFullYear()} ARS Hukuk | Trafik Kazası Tazminat Hesaplama Raporu</p>
        </div>
      </body>
      </html>
    `);
    printWindow.document.close();
    setTimeout(() => printWindow.print(), 300);
  };

  return (
    <>
      <Helmet>
        <title>TAZMİNAT HESAPLAMA | ARS HUKUK</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Trafik kazası tazminat hesaplama - ARS HUKUK"
          data-rh="true"
        />
        <link
          rel="canonical"
          href="https://www.arshukukburosu.com/tazminat-hesaplama"
        />
        <meta
          property="og:title"
          content="TAZMİNAT HESAPLAMA | ARS HUKUK"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="Trafik kazası tazminat hesaplama - ARS HUKUK"
        />
        <meta property="og:image" content="" />
        <meta
          property="og:url"
          content="https://www.arshukukburosu.com/tazminat-hesaplama"
        />
      </Helmet>

      <WhiteNavbar navbarSelection={"tazminat-hesaplama"} />
      <br></br>
      <br></br>
      <br></br>
      <br></br>

      <div>
        <Container style={{ fontFamily: "Nucleo Outline" }}>
          <div>
            <br />
            <h2
              className="ml-auto mr-auto text-center"
              style={{ color: "#123274", fontFamily: "Benguiat Regular" }}
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <b>TRAFİK KAZASI TAZMİNAT HESAPLAMA</b>
            </h2>
            <p
              className="text-center"
              style={{ maxWidth: "700px", margin: "16px auto 0" }}
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              Girilen verilere göre tahmini tazminat tutarını hesaplayın
            </p>
            <br />
          </div>

          {/* Form veya Sonuç */}
          {formGosterildi ? (
            <div
              className="card"
              style={{
                borderRadius: "12px",
                border: "none",
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                marginBottom: "24px",
              }}
              data-aos="zoom-in"
              data-aos-duration="1000"
            >
              <div
                style={{
                  background: "#123274",
                  padding: "16px 24px",
                  color: "white",
                }}
              >
                <h4
                  style={{
                    color: "white",
                    fontSize: "1.2rem",
                    fontWeight: 600,
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FaCalculator
                    style={{ marginRight: "12px", opacity: 0.9 }}
                  />
                  TAZMİNAT HESAPLAMA FORMU
                </h4>
              </div>

              <CardBody style={{ padding: "32px" }}>
                {hata && (
                  <Alert color="danger" className="mb-4 fw-bold">
                    <FaTimesCircle className="me-2" /> {hata}
                  </Alert>
                )}

                <Alert color="info" className="mb-4">
                  <FaInfoCircle className="me-2" />
                  Zorunlu alanlar işaretlenmiştir. Adım adım ilerleyin ve{" "}
                  <strong>Hesapla</strong> butonuna basın.
                </Alert>

                <Form onSubmit={handleSubmit}>
                  {/* Kişisel Bilgiler */}
                  <Row>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="adSoyad"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          <FaIdCard className="me-2" />
                          Ad Soyad (İsteğe Bağlı)
                        </Label>
                        <Input
                          type="text"
                          id="adSoyad"
                          name="adSoyad"
                          value={formData.adSoyad}
                          onChange={handleChange}
                          placeholder="Ad ve soyadınızı girin"
                          style={{
                            padding: "1rem 1.25rem",
                            borderColor: "#e9ecef",
                            fontSize: "1rem",
                            borderRadius: "9999px",
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="cinsiyet"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          Cinsiyet (İsteğe Bağlı)
                        </Label>
                        <Input
                          type="select"
                          id="cinsiyet"
                          name="cinsiyet"
                          value={formData.cinsiyet}
                          onChange={handleChange}
                          style={{
                            padding: "1rem 1.25rem",
                            borderColor: "#e9ecef",
                            fontSize: "1rem",
                            borderRadius: "9999px",
                          }}
                        >
                          <option value="">Seçiniz</option>
                          <option value="erkek">Erkek</option>
                          <option value="kadın">Kadın</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Tarih Bilgileri */}
                  <Row>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="dogumTarihi"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          Doğum Tarihi <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="date"
                          id="dogumTarihi"
                          name="dogumTarihi"
                          value={formData.dogumTarihi}
                          onChange={handleChange}
                          required
                          invalid={!!validationErrors.dogumTarihi}
                          style={{
                            padding: "1rem 1.25rem",
                            borderColor: "#e9ecef",
                            fontSize: "1rem",
                            borderRadius: "9999px",
                          }}
                        />
                        {validationErrors.dogumTarihi && (
                          <div className="text-danger mt-1 small">
                            <FaTimesCircle className="me-1" />{" "}
                            {validationErrors.dogumTarihi}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="kazaTarihi"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          <FaCarCrash className="me-2" />
                          Kaza Tarihi <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="date"
                          id="kazaTarihi"
                          name="kazaTarihi"
                          value={formData.kazaTarihi}
                          onChange={handleChange}
                          required
                          invalid={!!validationErrors.kazaTarihi}
                          style={{
                            padding: "1rem 1.25rem",
                            borderColor: "#e9ecef",
                            fontSize: "1rem",
                            borderRadius: "9999px",
                          }}
                        />
                        {validationErrors.kazaTarihi && (
                          <div className="text-danger mt-1 small">
                            <FaTimesCircle className="me-1" />{" "}
                            {validationErrors.kazaTarihi}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Telefon */}
                  <Row>
                    <Col md={12}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="telefon"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          Telefon Numarası{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="tel"
                          id="telefon"
                          name="telefon"
                          value={formData.telefon}
                          onChange={handleChange}
                          placeholder="Örn: 0555 555 55 55"
                          required
                          pattern="[0-9]{10,11}"
                          invalid={!!validationErrors.telefon}
                          style={{
                            padding: "1rem 1.25rem",
                            borderColor: "#e9ecef",
                            fontSize: "1rem",
                            borderRadius: "9999px",
                          }}
                        />
                        {validationErrors.telefon && (
                          <div className="text-danger mt-1 small">
                            <FaTimesCircle className="me-1" />{" "}
                            {validationErrors.telefon}
                          </div>
                        )}
                        <small
                          style={{
                            fontSize: "0.85rem",
                            color: "#6c757d",
                            marginTop: "8px",
                            display: "block",
                          }}
                        >
                          Size ulaşabileceğimiz telefon numarası
                        </small>
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Gelir ve Oranlar */}
                  <Row>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="gelir"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          Aylık Net Gelir (TL){" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <InputGroup>
                          <Input
                            type="number"
                            id="gelir"
                            name="gelir"
                            value={formData.gelir}
                            onChange={handleChange}
                            placeholder="Örn: 20000"
                            required
                            invalid={!!validationErrors.gelir}
                            style={{
                              padding: "1rem 1.25rem",
                              borderColor: "#e9ecef",
                              fontSize: "1rem",
                              borderRadius: "9999px 0 0 9999px",
                            }}
                          />
                          <InputGroupText
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderColor: "#e9ecef",
                              color: "#495057",
                              fontWeight: 600,
                              padding: "1rem 1rem",
                              borderRadius: "0 9999px 9999px 0",
                            }}
                          >
                            ₺
                          </InputGroupText>
                        </InputGroup>
                        {validationErrors.gelir && (
                          <div className="text-danger mt-1 small">
                            <FaTimesCircle className="me-1" />{" "}
                            {validationErrors.gelir}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="maluliyetOrani"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          Maluliyet Oranı (%){" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <InputGroup>
                          <Input
                            type="number"
                            id="maluliyetOrani"
                            name="maluliyetOrani"
                            value={formData.maluliyetOrani}
                            onChange={handleChange}
                            placeholder="Örn: 25"
                            required
                            invalid={!!validationErrors.maluliyetOrani}
                            style={{
                              padding: "1rem 1.25rem",
                              borderColor: "#e9ecef",
                              fontSize: "1rem",
                              borderRadius: "9999px 0 0 9999px",
                            }}
                          />
                          <InputGroupText
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderColor: "#e9ecef",
                              color: "#495057",
                              fontWeight: 600,
                              padding: "1rem 1rem",
                              borderRadius: "0 9999px 9999px 0",
                            }}
                          >
                            %
                          </InputGroupText>
                        </InputGroup>
                        {validationErrors.maluliyetOrani && (
                          <div className="text-danger mt-1 small">
                            <FaTimesCircle className="me-1" />{" "}
                            {validationErrors.maluliyetOrani}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="kusurOrani"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          Kusur Oranı (%)
                        </Label>
                        <InputGroup>
                          <Input
                            type="number"
                            id="kusurOrani"
                            name="kusurOrani"
                            value={formData.kusurOrani}
                            onChange={handleChange}
                            placeholder="Örn: 30"
                            style={{
                              padding: "1rem 1.25rem",
                              borderColor: "#e9ecef",
                              fontSize: "1rem",
                              borderRadius: "9999px 0 0 9999px",
                            }}
                          />
                          <InputGroupText
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderColor: "#e9ecef",
                              color: "#495057",
                              fontWeight: 600,
                              padding: "1rem 1rem",
                              borderRadius: "0 9999px 9999px 0",
                            }}
                          >
                            %
                          </InputGroupText>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "16px" }}>
                        <Label
                          htmlFor="tedaviMasraflari"
                          style={{
                            fontWeight: 600,
                            marginBottom: "6px",
                            fontSize: "0.95rem",
                            color: "#344767",
                          }}
                        >
                          Tedavi Masrafları (TL) (İsteğe Bağlı)
                        </Label>
                        <InputGroup>
                          <Input
                            type="number"
                            id="tedaviMasraflari"
                            name="tedaviMasraflari"
                            value={formData.tedaviMasraflari}
                            onChange={handleChange}
                            placeholder="Örn: 5000"
                            style={{
                              padding: "1rem 1.25rem",
                              borderColor: "#e9ecef",
                              fontSize: "1rem",
                              borderRadius: "9999px 0 0 9999px",
                            }}
                          />
                          <InputGroupText
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderColor: "#e9ecef",
                              color: "#495057",
                              fontWeight: 600,
                              padding: "1rem 1rem",
                              borderRadius: "0 9999px 9999px 0",
                            }}
                          >
                            ₺
                          </InputGroupText>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Butonlar */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "space-between",
                      marginTop: "24px",
                      gap: "16px",
                    }}
                  >
                    <Button
                      type="button"
                      onClick={formuTemizle}
                      size="lg"
                      style={{
                        backgroundColor: "white",
                        borderColor: "#6c757d",
                        color: "#6c757d",
                        padding: ".75rem 1.5rem",
                        fontWeight: 600,
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                      className="shadow-sm"
                    >
                      <FaTrash /> Formu Temizle
                    </Button>

                    <Button
                      type="submit"
                      size="lg"
                      disabled={loading}
                      style={{
                        backgroundColor: "#123274",
                        borderColor: "#123274",
                        padding: ".75rem 2rem",
                        fontWeight: 600,
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                      className="shadow"
                    >
                      {loading ? (
                        <>
                          <Spinner size="sm" /> Hesaplanıyor...
                        </>
                      ) : (
                        <>
                          <FaCalculator /> TAZMİNAT HESAPLA
                        </>
                      )}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </div>
          ) : (
            <>
              {sonuc && (
                <Card
                  style={{
                    borderRadius: "12px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                    border: "none",
                    overflow: "hidden",
                    backgroundColor: "white",
                    marginBottom: "24px",
                  }}
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <div
                    style={{
                      background: "#123274",
                      padding: "16px 24px",
                      color: "white",
                    }}
                  >
                    <h4
                      style={{
                        color: "white",
                        fontSize: "1.2rem",
                        fontWeight: 600,
                        margin: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <FaCalculator
                        style={{ marginRight: "12px", opacity: 0.9 }}
                      />
                      HESAPLAMA SONUCU
                    </h4>
                  </div>

                  <CardBody style={{ padding: "32px" }}>
                    <div className="text-center mb-3">
                      <h4
                        style={{
                          fontSize: "1.4rem",
                          fontWeight: 800,
                          color: "#344767",
                          marginBottom: "1rem",
                        }}
                      >
                        TOPLAM TAZMİNAT TUTARI
                      </h4>
                      <Badge color="light" pill>
                        Rapor No: {sonuc.hesaplamaDetaylari.raporNo}
                      </Badge>
                    </div>

                    <Row className="g-3 mb-3">
                      <Col md={4}>
                        <div
                          style={{
                            background: "#fff",
                            border: "1px solid #eaecef",
                            borderRadius: 12,
                            padding: "1.1rem 1.2rem",
                            height: "100%",
                            textAlign: "center",
                          }}
                        >
                          <div
                            style={{
                              fontSize: ".95rem",
                              color: "#6c757d",
                              fontWeight: 800,
                              textTransform: "uppercase",
                              marginBottom: 6,
                            }}
                          >
                            Maddi Tazminat
                          </div>
                          <div
                            style={{
                              fontSize: "1.6rem",
                              fontWeight: 900,
                              color: "#123274",
                            }}
                          >
                            {sonuc.tazminatDetaylari.maddiTazminat.toLocaleString(
                              "tr-TR"
                            )}{" "}
                            ₺
                          </div>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div
                          style={{
                            background: "#fff",
                            border: "1px solid #eaecef",
                            borderRadius: 12,
                            padding: "1.1rem 1.2rem",
                            height: "100%",
                            textAlign: "center",
                          }}
                        >
                          <div
                            style={{
                              fontSize: ".95rem",
                              color: "#6c757d",
                              fontWeight: 800,
                              textTransform: "uppercase",
                              marginBottom: 6,
                            }}
                          >
                            Manevi Tazminat
                          </div>
                          <div
                            style={{
                              fontSize: "1.6rem",
                              fontWeight: 900,
                              color: "#123274",
                            }}
                          >
                            {sonuc.tazminatDetaylari.maneviTazminat.toLocaleString(
                              "tr-TR"
                            )}{" "}
                            ₺
                          </div>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div
                          style={{
                            background: "#fff",
                            border: "1px solid #eaecef",
                            borderRadius: 12,
                            padding: "1.1rem 1.2rem",
                            height: "100%",
                            textAlign: "center",
                          }}
                        >
                          <div
                            style={{
                              fontSize: ".95rem",
                              color: "#6c757d",
                              fontWeight: 800,
                              textTransform: "uppercase",
                              marginBottom: 6,
                            }}
                          >
                            Toplam
                          </div>
                          <div
                            style={{
                              fontSize: "1.6rem",
                              fontWeight: 900,
                              color: "#198754",
                            }}
                          >
                            {sonuc.tazminatDetaylari.toplamTazminat.toLocaleString(
                              "tr-TR"
                            )}{" "}
                            ₺
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {/* Detay Tabloları */}
                    <Row className="mt-4">
                      <Col md={6} className="mb-3">
                        <h5 className="mb-3">Hesaplama Parametreleri</h5>
                        <Table bordered responsive className="bg-white">
                          <tbody>
                            <tr>
                              <th className="bg-light" width="40%">
                                Ad Soyad
                              </th>
                              <td>{sonuc.hesaplamaBilgileri.adSoyad}</td>
                            </tr>
                            <tr>
                              <th className="bg-light">Yaş</th>
                              <td>{sonuc.hesaplamaBilgileri.yas} yıl</td>
                            </tr>
                            <tr>
                              <th className="bg-light">Cinsiyet</th>
                              <td>
                                {sonuc.hesaplamaBilgileri.cinsiyet
                                  ? sonuc.hesaplamaBilgileri.cinsiyet ===
                                    "erkek"
                                    ? "Erkek"
                                    : "Kadın"
                                  : "-"}
                              </td>
                            </tr>
                            <tr>
                              <th className="bg-light">Doğum Tarihi</th>
                              <td>{sonuc.hesaplamaBilgileri.dogumTarihi}</td>
                            </tr>
                            <tr>
                              <th className="bg-light">Kaza Tarihi</th>
                              <td>{sonuc.hesaplamaBilgileri.kazaTarihi}</td>
                            </tr>
                            <tr>
                              <th className="bg-light">Telefon</th>
                              <td>{sonuc.hesaplamaBilgileri.telefon}</td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                      <Col md={6} className="mb-3">
                        <h5 className="mb-3">Tazminat Detayları</h5>
                        <Table bordered responsive className="bg-white">
                          <tbody>
                            <tr>
                              <th className="bg-light">Aylık Gelir</th>
                              <td>
                                {(+sonuc.hesaplamaBilgileri.gelir).toLocaleString(
                                  "tr-TR"
                                )}{" "}
                                ₺
                              </td>
                            </tr>
                            <tr>
                              <th className="bg-light">Maluliyet Oranı</th>
                              <td>
                                %{sonuc.hesaplamaBilgileri.maluliyetOrani}
                              </td>
                            </tr>
                            <tr>
                              <th className="bg-light">Kusur Oranı</th>
                              <td>%{sonuc.hesaplamaBilgileri.kusurOrani}</td>
                            </tr>
                            {+sonuc.hesaplamaBilgileri.tedaviMasraflari > 0 && (
                              <tr>
                                <th className="bg-light">Tedavi Masrafları</th>
                                <td>
                                  {(+sonuc.hesaplamaBilgileri.tedaviMasraflari).toLocaleString(
                                    "tr-TR"
                                  )}{" "}
                                  ₺
                                </td>
                              </tr>
                            )}
                            <tr className="bg-primary text-white">
                              <th>TOPLAM</th>
                              <td>
                                {sonuc.tazminatDetaylari.toplamTazminat.toLocaleString(
                                  "tr-TR"
                                )}{" "}
                                ₺
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>

                    {/* Butonlar */}
                    <div
                      className="d-flex justify-content-center mt-4"
                      style={{ gap: 12 }}
                    >
                      <Button
                        onClick={sonucuYazdir}
                        size="lg"
                        style={{
                          backgroundColor: "white",
                          borderColor: "#6c757d",
                          color: "#6c757d",
                          padding: ".75rem 1.5rem",
                          fontWeight: 600,
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        className="shadow-sm"
                      >
                        <FaPrint /> Raporu Yazdır
                      </Button>
                      <Button
                        onClick={yeniHesaplamayap}
                        size="lg"
                        style={{
                          backgroundColor: "#123274",
                          borderColor: "#123274",
                          padding: ".75rem 1.5rem",
                          fontWeight: 600,
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        className="shadow"
                      >
                        <FaCalculator /> Yeni Hesaplama
                      </Button>
                    </div>

                    <div
                      style={{
                        textAlign: "center",
                        marginTop: 12,
                        color: "#6c757d",
                        fontWeight: 700,
                      }}
                    >
                      Rapor No: {sonuc.hesaplamaDetaylari.raporNo} |{" "}
                      {currentDate} tarihinde {currentUser} tarafından
                      oluşturulmuştur.
                    </div>
                  </CardBody>
                </Card>
              )}
            </>
          )}
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default TrafikKazaTazminatHesaplama;